import React from 'react';

import { Col, Row, Typography } from 'antd';

const PageTitle = ({ title, subtitle, children }) => (
  <Row style={{ paddingBottom: '24px' }}>
    <Col xs={12}>
      <Typography.Title
        level={5}
        style={{ marginBottom: subtitle ? 2 : undefined }}
      >
        {title}
      </Typography.Title>
      {subtitle && (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {subtitle}
        </Typography.Text>
      )}
    </Col>
    {children && (
      <Col xs={12} style={{ textAlign: 'right' }}>
        {children}
      </Col>
    )}
  </Row>
);

export default PageTitle;
